import React, { useContext } from 'react'
import { useTheme } from '@emotion/react'
import { color } from 'utils/style'
import IconButton from './IconButton'
import TrashIcon from 'components/TrashIcon'
import FavoritesContext from './FavoritesContext'
import styled from '@emotion/styled'

const StyledIconButton = styled(IconButton)`
  padding: 20px;
`

const RemoveFavoriteButton = ({ favorite }) => {
  const theme = useTheme()
  const { removeFavorite } = useContext(FavoritesContext)

  return (
    <StyledIconButton
      type="button"
      aria-label="Remove Favorite"
      onClick={() => removeFavorite(favorite)}
    >
      <TrashIcon
        title="Remove Favorite"
        strokeColor={color('danger', { theme })}
      />
    </StyledIconButton>
  )
}

export default RemoveFavoriteButton
